import { lazy } from 'react';
import { lazyRetry } from '../../utils/general';

const Footer = lazy(() => lazyRetry(() => import('./Footer')));
export { Footer };
